module.exports = __webpack_public_path__ + "education-48.1407fd2c6dbb3280fe42.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/education/webfont/education-48.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/education/webfont/education-48.svg
// module chunks = styles